import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Tooltip } from 'antd';
import { GenericInput } from '../../components';
import { ClickableIcon } from '../../../common/components';
import { SearchIcon } from '../../../custom_shared/icons';
import { InputModel } from '../../models';
import { InputWithoutSource } from '../../componentTypes';
import { useInputBlurAction } from '../../hooks';
import { useAppStore } from '../../stores';
import { InstanceUtils } from '../../misc';

const BusinessIdInput: InputWithoutSource = ({ input }) => {
    const { actionStore, businessSearchStore } = useAppStore();

    const { handleFocus, handleBlur, handleKeyDown } = useInputBlurAction(input, () =>
        actionStore.changeBusinessId(input.worksheetId, input.nodeId)
    );

    const handleBusinessSearchClick = () => {
        if (InstanceUtils.isBalanceInformationNode(input.node)) {
            businessSearchStore.initializeSearchModal(input.node);
        }
    };

    const handleBusinessSearchPointerDown = (event: React.PointerEvent<SVGSVGElement>) => {
        event.preventDefault();
        event.stopPropagation();
    };

    return (
        <GenericInput
            label={input.name}
            input={input}
            onFocus={handleFocus}
            onBlur={handleBlur}
            onKeyDown={handleKeyDown}
            suffix={
                businessSearchStore.isBusinessSearchSupported && (
                    <Tooltip title="Business Search">
                        <ClickableIcon
                            icon={SearchIcon}
                            width={18}
                            height={18}
                            onClick={handleBusinessSearchClick}
                            onPointerDown={handleBusinessSearchPointerDown}
                        />
                    </Tooltip>
                )
            }
        />
    );
};

BusinessIdInput.meta = {
    inputType: InputModel.name
};

export default observer(BusinessIdInput);
